import { render, staticRenderFns } from "./UnsavedList.vue?vue&type=template&id=13e5d3ce&scoped=true&"
import script from "./UnsavedList.vue?vue&type=script&lang=js&"
export * from "./UnsavedList.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedList.vue?vue&type=style&index=0&id=13e5d3ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e5d3ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VDivider,VExpandTransition,VIcon,VSpacer})
